export default "__VITE_ASSET__Cjry2TvQ__"